// Função que retorna total de imoveis de uma Agencia.
// Criado por Humberto Bruzetti
// Paprica Comunicação
import axios from 'axios';
import convertToArray from './convertToArray';
import * as def from './definitions';

function listarDestaques(finalidade, order, quantidade = 1, destaque, callback) {
  // console.log('Iniciado listarDestaques');
  // console.log(`ENTRADA: ${JSON.stringify(order, null, 4)}`);
  const filter = Object.assign(finalidade, { ExibirNoSite: 'Sim' });
  let pesquisa = {advFilter: filter, 'fields':['Status','CodigoAgencia', 'Bairro', 'CategoriaImovel', 'TituloImovel', 'ProntoNovoMorar', 'Lancamento', 'LancamentosProntos', 'Proposta', 'Dormitorios', 'AreaPrivativa', 'FotoDestaque', 'FotoDestaquePequena', 'ValorVenda', 'OcultarPrecoSite'], 'paginacao': {'pagina': 1, 'quantidade': quantidade}}
  let url = def.LISTARDESTAQUES;
  
  if (destaque) {
    pesquisa = {"filter":{"Codigo":destaque},"fields":["Status","CodigoAgencia","Bairro","CategoriaImovel","TituloImovel","ProntoNovoMorar","Lancamento","LancamentosProntos","Proposta","Dormitorios","AreaPrivativa","FotoDestaque","FotoDestaquePequena","ValorVenda","ValorLocacao","OcultarPrecoSite"]}
    url = def.PESQUISARIMOVEIS;
  }

  pesquisa.order = JSON.parse(order);
  axios({
    method: 'get',
    url: url,
    params: {
      key: def.KEY,
      pesquisa,
    },
  })
    .then((response) => {
      console.log("response:", response);

      convertToArray(response.data, (cb) => {
        callback(cb);
        console.log("callback:", cb);
      });
    })
    .catch((error) => {
      callback(error);
    });
}

module.exports = listarDestaques;



// WEBPACK FOOTER //
// ./src/assets/js/apiFunctions/listarDestaques.js